import React, { useEffect, useState } from 'react'
import { Input, Form, Modal, Popover } from 'antd'
// import styles from './Less/input.less'
import PostcodeLookup from '../Utils/PostcodeLookup'
import { SearchOutlined } from '@ant-design/icons'
const PostCodeInput = (props: {
    name: string
    label: string
    placeHolder: string
    reuireMessage: string
    setAddressDetails: React.Dispatch<
        React.SetStateAction<{
            line_1: string
            line_2: string
            line_3: string
            post_town: string
            postcode: string
            country: string
        }>
    >
    require?: boolean
}): React.ReactElement => {
    const {
        name,
        label,
        placeHolder,
        reuireMessage,
        setAddressDetails,
        require = true,
    } = props
    const [postLookupModelOpen, setPostLookupModelOpen] = useState(false)
    const [address, setAddress] = useState({
        line_1: '',
        line_2: '',
        line_3: '',
        post_town: '',
        postcode: '',
        country: '',
    })
    useEffect(() => {
        setAddressDetails(address)
    }, [address])
    const content = (
        <div>
            <p> Click and enter your UK postcode and get accurate address</p>
        </div>
    )
    const suffix = (
        <Popover content={content} title="Postcode Lookup!">
            <SearchOutlined
                // style={{
                //     fontSize: 16,
                //     color: '#1677ff',
                // }}
                onClick={() => {
                    setPostLookupModelOpen(true)
                }}
            />
        </Popover>
    )

    const onClosePostLookupModel = (): void => {
        setPostLookupModelOpen(false)
    }
    return (
        <>
            <Form.Item
                label={label}
                name={name}
                rules={[{ required: require, message: reuireMessage }]}
            >
                <Input
                    placeholder={placeHolder}
                    addonAfter={suffix}
                    allowClear
                    maxLength={10}
                />
            </Form.Item>
            <Modal
                footer={null}
                onCancel={onClosePostLookupModel}
                width={'45%'}
                title={'Process Remarks'}
                open={postLookupModelOpen}
            >
                <PostcodeLookup
                    onAddressSelected={(address) => {
                        setAddress(address)
                    }}
                    onclose={onClosePostLookupModel}
                />
            </Modal>
        </>
    )
}

export default PostCodeInput
